// Structured Data per SEO - Schema.org JSON-LD

const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://iltuoamaro.it';
const LOGO_URL = process.env.REACT_APP_LOGO_URL || 'https://customer-assets.emergentagent.com/job_spirit-craft/artifacts/zmnohwp6_logo-il-tuo-amaro%401000x.webp';
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://trade-fair-preview.preview.emergentagent.com';

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Liquorificio Lacinio - Il Tuo Amaro",
  "url": SITE_URL,
  "logo": LOGO_URL,
  "description": "Migliore Distilleria Italiana 2025 e produttore del Miglior Amaro al Mondo. Liquori artigianali personalizzati B2B dalla Calabria.",
  "foundingDate": "2019-12",
  "founders": [
    {
      "@type": "Person",
      "name": "Davide Milone"
    },
    {
      "@type": "Person",
      "name": "Michele Sotero"
    }
  ],
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Crotone",
    "addressRegion": "KR",
    "addressCountry": "IT"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "Customer Service",
    "availableLanguage": ["Italian", "English"]
  },
  "sameAs": [
    "https://www.facebook.com/iltuoamaro",
    "https://www.instagram.com/iltuoamaro"
  ],
  "award": [
    "Migliore Distilleria Italiana 2025",
    "Miglior Amaro al Mondo"
  ]
};

export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "Distillery",
  "name": "Liquorificio Lacinio",
  "image": `${BACKEND_URL}/api/upload/serve/static/images/liquorificio.webp`,
  "@id": SITE_URL,
  "url": SITE_URL,
  "telephone": "",
  "priceRange": "€€",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Zona Industriale",
    "addressLocality": "Crotone",
    "postalCode": "88900",
    "addressRegion": "KR",
    "addressCountry": "IT"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 39.0858,
    "longitude": 17.1247
  },
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday"
    ],
    "opens": "09:00",
    "closes": "18:00"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "5",
    "reviewCount": "150"
  }
};

export const productSchema = (product) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  "name": product.name,
  "image": product.image,
  "description": product.description,
  "brand": {
    "@type": "Brand",
    "name": "Il Tuo Amaro"
  },
  "offers": {
    "@type": "Offer",
    "url": `${SITE_URL}/builder`,
    "priceCurrency": "EUR",
    "price": product.price,
    "availability": "https://schema.org/InStock",
    "priceValidUntil": new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0]
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "reviewCount": "87"
  }
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": `${SITE_URL}${item.url}`
  }))
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Il Tuo Amaro",
  "url": SITE_URL,
  "potentialAction": {
    "@type": "SearchAction",
    "target": {
      "@type": "EntryPoint",
      "urlTemplate": `${SITE_URL}/search?q={search_term_string}`
    },
    "query-input": "required name=search_term_string"
  }
};
